import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/helpsystems`;

export default {
  getHelpSystemByUniqueId(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/byfrontuniqueid`, {
      baseURL,
      params,
      headers,
    });
  },
 
};
